import { Link } from 'react-router-dom';

import EmailVerificationRequestForm from './EmailVerificationRequestForm';

function VerifyEmailRequestPage() {
    return (
        <div className="app">
            <main className="app__shell">
                <section className="panel panel--auth">
                    <h1>Подтверждение почты</h1>
                    <EmailVerificationRequestForm />
                    <Link className="button-link" to="/">
                        Вернуться на главную
                    </Link>
                </section>
            </main>
        </div>
    );
}

export default VerifyEmailRequestPage;
